export const toWeightedReturn = (stock) => ((stock.weight ?? 0) * (stock.return_pct ?? 0)) / 100

const formatPct = (value) => `${value >= 0 ? '+' : ''}${value.toFixed(2)}%`

const pctColor = (value) => {
  if (value > 0) return '#16a34a'
  if (value < 0) return '#dc2626'
  return '#64748b'
}

export const renderPortfolioTooltipTable = ({
  symbol,
  weightPct,
  returnPct,
  weightedReturnPct,
}) => `
  <div style="padding:6px 8px;font-size:11px;line-height:1.25;min-width:180px;">
    <table style="border-collapse:collapse;width:100%;">
      <tr><td style="padding:1px 0;color:#64748b;">Symbol</td><td style="padding:1px 0;text-align:right;font-weight:700;">${symbol}</td></tr>
      <tr><td style="padding:1px 0;color:#64748b;">Portfolio Weight</td><td style="padding:1px 0;text-align:right;font-weight:600;">${formatPct(weightPct)}</td></tr>
      <tr><td style="padding:1px 0;color:#64748b;">Return</td><td style="padding:1px 0;text-align:right;font-weight:700;color:${pctColor(returnPct)};">${formatPct(returnPct)}</td></tr>
      <tr><td style="padding:1px 0;color:#64748b;">Weighted Return</td><td style="padding:1px 0;text-align:right;font-weight:700;color:${pctColor(weightedReturnPct)};">${formatPct(weightedReturnPct)}</td></tr>
    </table>
  </div>
`
